export const nhaCungCapEndpoint = `${
  process.env.REACT_APP_ENDPOINT_URL
}/nha-cung-cap`;

export const NHA_CUNG_CAP_PREFIX_URL = "/nha-cung-cap";
